import { Module } from 'vuex'

import { FamilyState } from '@/store/family/types'
import RootState from '@/store/types/RootState'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export default <Module<FamilyState, RootState>>{
  namespaced: true,
  actions,
  getters,
  mutations,
  state: {
    familyMembers: [],
    hasAttemptedToLoadData: false,
  },
}
